export const CONGELACAO_FINALIZADA = 'CONGELACAO_FINALIZADA';
export const congelacaoFinalizada = (congelacaoFinalizada) => ({
  type: CONGELACAO_FINALIZADA,
  payload: {
    congelacaoFinalizada,
  },
});

export const COLLAPSED_CONTAINER_EXAMES = 'COLLAPSED_CONTAINER_EXAMES';
export const collapedContainerExames = (collapseContainerExames) => ({
  type: COLLAPSED_CONTAINER_EXAMES,
  payload: {
    collapseContainerExames: collapseContainerExames,
  },
});


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/congelacao/congelacao.action.js